import {
  ModalBackdrop,
  ModalContent,
  ModalTitle,
} from "components/common/modals/modal.styles";
import React from "react";
import { ActionType } from "store/types";
import { ButtonContainer, ConfirmButton, RejectButton } from "./index.styles";

interface ConfirmActionModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  actionType: ActionType;
}

const ConfirmActionModal: React.FC<ConfirmActionModalProps> = ({ open, onClose, onConfirm, actionType }) => {
  if (!open) return null;

  const getModalContent = () => {
    switch (actionType) {
      case ActionType.CONFIRM:
        return {
          title: "Confirm Attendance",
          message: "Are you sure you want to confirm your attendance to this event?",
          confirmText: "Yes, I'll attend"
        };
      case ActionType.DECLINE:
        return {
          title: "Decline Attendance",
          message: "Are you sure you want to decline this event invitation?",
          confirmText: "Yes, decline"
        };
      default:
        return {
          title: "Are you sure?",
          message: "This action is irreversible.",
          confirmText: "Yes, continue"
        };
    }
  };

  const content = getModalContent();

  return (
    <ModalBackdrop>
      <ModalContent style={{ maxWidth: 380, textAlign: 'center' }}>
        <ModalTitle>{content.title}</ModalTitle>
        <div style={{ color: '#6B7280', margin: '1rem 0 2rem 0', fontSize: '1.05rem' }}>
          {content.message}
        </div>
        <ButtonContainer>
          <RejectButton onClick={onClose} variant="contained">Cancel</RejectButton>
          <ConfirmButton onClick={onConfirm} variant="contained">
            {content.confirmText}
          </ConfirmButton>
        </ButtonContainer>
      </ModalContent>
    </ModalBackdrop>
  );
};

export default ConfirmActionModal; 